export default __webpack_public_path__ + "static/media/icon-check-white.51da5aba.svg";